import { render, staticRenderFns } from "./CrewExtraRow.vue?vue&type=template&id=606f5e44&scoped=true"
import script from "./CrewExtraRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrewExtraRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrewExtraRow.vue?vue&type=style&index=0&id=606f5e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f5e44",
  null
  
)

export default component.exports